"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviewDomain = exports.getSafePreviewName = exports.PREVIEW_BRANCH_PREFIX = void 0;
exports.PREVIEW_BRANCH_PREFIX = 'preview-';
const PREVIEW_MAX_LENGTH = 20;
/**
 * Gets the safe version of a preview branch name.
 * @param previewName the name of the preview
 */
function getSafePreviewName(previewName) {
    const [before] = previewName.split('#');
    const result = before.replace(exports.PREVIEW_BRANCH_PREFIX, '').replace(/[^\dA-Za-z]/g, '');
    return result.slice(0, PREVIEW_MAX_LENGTH);
}
exports.getSafePreviewName = getSafePreviewName;
/**
 * Gets the subdomain for a preview.
 * @param previewName the name of the preview
 */
function getPreviewDomain(previewName) {
    return `pre-${getSafePreviewName(previewName.replace(/_/g, '-')).toLowerCase()}`;
}
exports.getPreviewDomain = getPreviewDomain;
//# sourceMappingURL=preview.js.map